import React, { useState } from 'react';
import { Modal, Form, Input, DatePicker, Button, message, Alert } from 'antd';
import { createLink } from '../api';
import { colors } from '../theme';

export default function CreateLinkModal({ open, getToken, onClose }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  async function handleSubmit() {
    const values = await form.validateFields();
    setLoading(true);
    try {
      const token = await getToken();
      const payload = {
        target_url: values.target_url,
        slug: values.slug || undefined,
        description: values.description || undefined,
        expires_at: values.expires_at ? values.expires_at.toISOString() : undefined
      };
      const res = await createLink(token, payload);
      message.success(`Link created: ai.quadreal.com/${res.slug}`);
      form.resetFields();
      onClose();
    } catch (err) {
      message.error(err.response?.data?.error || 'Failed to create link');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      title="New link"
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>Cancel</Button>,
        <Button key="submit" type="primary" loading={loading} onClick={handleSubmit}
          style={{ background: colors.blue }}>
          Create
        </Button>
      ]}
    >
      <Alert
        type="warning"
        message="Link destinations are monitored for work appropriate material and subject to follow-up."
        style={{ marginBottom: 16 }}
        showIcon
      />
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item name="target_url" label="Target URL" rules={[{ required: true, message: 'Required' }]}>
          <Input placeholder="https://..." />
        </Form.Item>
        <Form.Item name="slug" label="Custom slug (optional)">
          <Input placeholder="Auto-generated if blank" />
        </Form.Item>
        <Form.Item name="description" label="Description (optional)">
          <Input />
        </Form.Item>
        <Form.Item name="expires_at" label="Expiry date (optional)">
          <DatePicker style={{ width: '100%' }} />
        </Form.Item>
      </Form>
    </Modal>
  );
}
